module.exports = __webpack_public_path__ + "static/media/Bill help.3217fbf2.svg";